/**
 * State Management
 */
export class BookingStateManager {
    constructor(experts) {
        this.experts = experts;
        this.state = {
            isOpen: false,
            currentExpertId: experts.length > 0 ? experts[0].id : null,
            expertStates: {}
        };
        this.experts.forEach(expert => {
            this.state.expertStates[expert.id] = {
                date: null,
                time: null,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                step: 1,
                currentDate: new Date(),
                availableDates: []
            };
        });
    }
    get isOpen() {
        return this.state.isOpen;
    }
    set isOpen(value) {
        this.state.isOpen = value;
    }
    get currentExpertId() {
        return this.state.currentExpertId;
    }
    set currentExpertId(id) {
        this.state.currentExpertId = id;
    }
    getExpertState(expertId) {
        return this.state.expertStates[expertId];
    }
    getAllExpertStates() {
        return this.state.expertStates;
    }
    getCurrentExpert() {
        return this.experts.find(e => e.id === this.state.currentExpertId);
    }
}
